// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/compliance/legal_terms/v1/legal_terms.proto (package stailer_service_specification.compliance.legal_terms.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { enumDesc, fileDesc, messageDesc, tsEnum } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_enum_description } = require("../../../../description_support/v1/enum_description_pb");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/compliance/legal_terms/v1/legal_terms.proto.
 */
const file_stailer_service_specification_compliance_legal_terms_v1_legal_terms = /*@__PURE__*/
  fileDesc("CklzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9jb21wbGlhbmNlL2xlZ2FsX3Rlcm1zL3YxL2xlZ2FsX3Rlcm1zLnByb3RvEjdzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5jb21wbGlhbmNlLmxlZ2FsX3Rlcm1zLnYxIqEBCg5FbnZpcm9ubWVudFVybBJGCgpwcm9kdWN0aW9uGAEgASgJQjKSghkb5pys55Wq55Kw5aKD44GuVVJM44Gn44GZ44CCqoIZD+acrOeVqueSsOWig1VSTBJHCgtkZXZlbG9wbWVudBgCIAEoCUIykoIZG+mWi+eZuueSsOWig+OBrlVSTOOBp+OBmeOAgqqCGQ/plovnmbrnkrDlooNVUkwizwIKEVNlcnZpY2VSZWd1bGF0aW9uEqIBCgR0eXBlGAEgASgOMk4uc3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24uY29tcGxpYW5jZS5sZWdhbF90ZXJtcy52MS5TZXJ2aWNlUmVndWxhdGlvblR5cGVCRJKCGTbjgrXjg7zjg5PjgrnjgavplqLjgZnjgovopo/lrprpoIXnm67jga7nqK7liKXjgafjgZnjgIKqghkG56iu5YilEpQBCgN1cmwYAiABKAsyRy5zdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5jb21wbGlhbmNlLmxlZ2FsX3Rlcm1zLnYxLkVudmlyb25tZW50VXJsQj6Sghkz44K144O844OT44K544Gr6Zai44GZ44KL6KaP5a6a6aCF55uu44GuVVJM44Gn44GZ44CCqoIZA1VSTCriAQoVU2VydmljZVJlZ3VsYXRpb25UeXBlEkwKI1NFUlZJQ0VfUkVHVUxBVElPTl9UWVBFX1VOU1BFQ0lGSUVEEAAaI+qCGRLmnKrmjIflrprjgafjgZnjgIL6ghkJ5pyq5oyH5a6aEnUKIlNFUlZJQ0VfUkVHVUxBVElPTl9UWVBFX0RJU0NMQUlNRVIQAhpN6oIZLeWFjeiyrOS6i+mgheODu+iRl+S9nOaoqeOBq+OBpOOBhOOBpuOBp+OBmeOAgvqCGRjlhY3osqzkuovpoIXjg7vokZfkvZzmqKkiBAgBEAFiBnByb3RvMw", [file_description_support_v1_enum_description, file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.compliance.legal_terms.v1.EnvironmentUrl.
 * Use `create(EnvironmentUrlSchema)` to create a new message.
 */
const EnvironmentUrlSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_compliance_legal_terms_v1_legal_terms, 0);

/**
 * Describes the message stailer_service_specification.compliance.legal_terms.v1.ServiceRegulation.
 * Use `create(ServiceRegulationSchema)` to create a new message.
 */
const ServiceRegulationSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_compliance_legal_terms_v1_legal_terms, 1);

/**
 * Describes the enum stailer_service_specification.compliance.legal_terms.v1.ServiceRegulationType.
 */
const ServiceRegulationTypeSchema = /*@__PURE__*/
  enumDesc(file_stailer_service_specification_compliance_legal_terms_v1_legal_terms, 0);

/**
 * サービス規定項目の種別を表します。
 *
 * @generated from enum stailer_service_specification.compliance.legal_terms.v1.ServiceRegulationType
 */
const ServiceRegulationType = /*@__PURE__*/
  tsEnum(ServiceRegulationTypeSchema);


exports.file_stailer_service_specification_compliance_legal_terms_v1_legal_terms = file_stailer_service_specification_compliance_legal_terms_v1_legal_terms;
exports.EnvironmentUrlSchema = EnvironmentUrlSchema;
exports.ServiceRegulationSchema = ServiceRegulationSchema;
exports.ServiceRegulationTypeSchema = ServiceRegulationTypeSchema;
exports.ServiceRegulationType = ServiceRegulationType;
